import React from "react";
import {Col, Row} from "react-bootstrap";
import Dropdown from "react-dropdown";

export default function Sort(props) {

    return (
        <Row>
            <Col md={2} className='PullLeftSort pr-0'>
                <p className='ml-3'>Sort By:</p>
            </Col>
            <Col md={8} className='pl-0'>
                <Dropdown
                    controlClassName='sortControl'
                    blurInputOnSelect
                    options={props.sortOptions}
                    onChange={(option) => props.setSelectedSort(option.value)}
                    value={props.value}/>
            </Col>
        </Row>
    )
}